import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "login-content lie" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "content lie"
}
const _hoisted_4 = { class: "register-box row" }
const _hoisted_5 = {
  key: 1,
  class: "content lie"
}
const _hoisted_6 = {
  class: "register-box row",
  style: {"justify-content":"center"}
}
const _hoisted_7 = {
  class: "register-box row",
  style: {"justify-content":"center"}
}
const _hoisted_8 = {
  key: 2,
  class: "content lie"
}
const _hoisted_9 = { class: "register-box row" }

import { useLocale } from '@/hooks/useLocale';
import { useUserStore } from '@/store/UserStore';
import { fetchResetPassword, InputRegister, InputResetPassword } from '@/typescript/Services/Api/AuthApi';
import { SendEmailCodeAsync } from '@/typescript/Services/Api/EmailApi';
import Global from '@/utils/Global';
import Tools from '@/utils/Tools';
import { inject, ref, watch } from 'vue';
type InputType = "login" | "register" | "forgotPassword";

export default /*@__PURE__*/_defineComponent({
  __name: 'LoginComponent',
  setup(__props, { expose: __expose }) {

const active = ref<InputType>("login");
const TimeDown = ref<number>(0);
const userStore = useUserStore();
const local = useLocale();
const IsMobile = inject<boolean>("IsMobile");
const registerObj = ref<InputRegister>({
    Email: "",
    EmailCode: "",
    Password: "",
    ParentAccountUid: "",
    Phone: ""
});

const resetPasswordObj = ref<InputResetPassword & {
    ResetPassword: string
}>({
    Email: "",
    EmailCode: "",
    Password: "",
    ResetPassword: ""
});

const userName = ref('');
const password = ref('');
const show = ref(false);

watch(active, (_n, _o) => {
    switch (_n) {
        case "register":
            const EXCHANGE_SHARE_UID = Tools.GetLocalStorage('EXCHANGE_SHARE_UID', "");
            registerObj.value.ParentAccountUid = EXCHANGE_SHARE_UID;
            break;
    }
});

/**
 * 显示登录框
 */
function Show() {
    userName.value = '';
    password.value = '';
    show.value = true;
}
/**
 * 关闭登录框
 */
function Close() {
    show.value = false;
}

/**
 * 显示注册
 */
function ShowRegister() {
    active.value = "register";
    Show();
}

/**
 * 显示忘记密码
 */
function ShowForgotPassword() {
    active.value = "forgotPassword";
    Show();
}

/**
 * 显示登录框
 */
function ShowLogin(flag: boolean = false) {
    if (!flag)
        if (show.value)
            return;
    active.value = "login";
    Show();
}

/**
 * 去登录
 */
function ToLogin() {
    if (Tools.IsNull(userName.value)) {
        Tools.AlertError(local.t('components.LoginComponent.sjhbnwk'));
        return;
    }
    if (Tools.IsNull(password.value)) {
        Tools.AlertError(local.t('components.LoginComponent.mmbnwk'));
        return;
    }

    Global.ToLoginAsync({
        userName: userName.value,
        password: password.value
    }).then(flag => {
        if (flag) {
            Close();
            userStore.UpdateUserDataAsync();
        }
    })
}



/**
 * 发送邮件验证码
 */
function SendEmailCode(email: string) {
    if (Tools.IsNull(email)) {
        Tools.AlertError(local.t('components.LoginComponent.qsryx'));
        return;
    }
    TimeDown.value = -1;
    SendEmailCodeAsync(email).then(resp => {
        if (resp.CheckIsOk()) {
            TimeDown.value = 60;
            StartTimeDown();
            Tools.AlertSuccess(local.t('components.LoginComponent.yzmyfs'));
        }
    });
}

/**
 * 开始倒计时
 */
function StartTimeDown() {
    let timeDown = TimeDown.value;
    if (timeDown > 0) {
        TimeDown.value--;
        if (TimeDown.value <= 0)
            TimeDown.value = 0;
        setTimeout(StartTimeDown, 1000);
    }
}


/**
 * 注册账号
 */
async function ToRegisterAsync() {
    if (await Global.RegisterAsync(registerObj.value)) {
        Close();
        userStore.UpdateUserDataAsync();
    }
}

/**
 * 重置密码
 */
function ResetPassword() {
    fetchResetPassword(resetPasswordObj.value).then(resp => {
        if (resp.CheckIsOk()) {
            StartTimeDown();
            Tools.AlertSuccess(local.t('components.LoginComponent.czmmcg'));
        }
    });
}



__expose({
    ShowLogin
})


return (_ctx: any,_cache: any) => {
  const _component_var_icon = _resolveComponent("var-icon")!
  const _component_var_input = _resolveComponent("var-input")!
  const _component_VarButton = _resolveComponent("VarButton")!
  const _component_var_link = _resolveComponent("var-link")!
  const _component_VarLoading = _resolveComponent("VarLoading")!

  return (show.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['login-body lie', _unref(IsMobile) ? '' : 'pc-login-body'])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            class: "my-icon",
            src: require('@/assets/logo.png')
          }, null, 8, _hoisted_2),
          (active.value == 'login')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_var_input, {
                  class: "input",
                  modelValue: userName.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userName).value = $event)),
                  placeholder: _ctx.$t('components.LoginComponent.emailorphone')
                }, {
                  "prepend-icon": _withCtx(() => [
                    _createVNode(_component_var_icon, {
                      name: "shouji",
                      namespace: "icon"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"]),
                _createVNode(_component_var_input, {
                  class: "input",
                  type: "password",
                  modelValue: password.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                  placeholder: _ctx.$t('components.LoginComponent.qsrmm')
                }, {
                  "prepend-icon": _withCtx(() => [
                    _createVNode(_component_var_icon, {
                      name: "mima",
                      namespace: "icon"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"]),
                _createVNode(_component_VarButton, {
                  class: "login-button",
                  type: "primary",
                  onClick: ToLogin
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('components.LoginComponent.login')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_var_link, {
                    type: "primary",
                    underline: "none",
                    onClick: ShowRegister
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('components.LoginComponent.register')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_var_link, {
                    type: "primary",
                    underline: "none",
                    onClick: ShowForgotPassword
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('components.LoginComponent.wjmm')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : (active.value == 'register')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_var_input, {
                    modelValue: registerObj.value.Email,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((registerObj.value.Email) = $event)),
                    class: "input",
                    type: "email",
                    placeholder: _ctx.$t('components.LoginComponent.dzyj')
                  }, {
                    "prepend-icon": _withCtx(() => [
                      _createVNode(_component_var_icon, {
                        name: "youxiang",
                        namespace: "icon"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"]),
                  _createVNode(_component_var_input, {
                    class: "input",
                    type: "text",
                    modelValue: registerObj.value.EmailCode,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((registerObj.value.EmailCode) = $event)),
                    placeholder: _ctx.$t('components.LoginComponent.email_code')
                  }, {
                    "prepend-icon": _withCtx(() => [
                      _createVNode(_component_var_icon, {
                        name: "yanzhengyanzhengma",
                        namespace: "icon"
                      })
                    ]),
                    "append-icon": _withCtx(() => [
                      (TimeDown.value > 0)
                        ? (_openBlock(), _createBlock(_component_VarButton, {
                            key: 0,
                            type: "default"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(TimeDown.value) + "s ", 1)
                            ]),
                            _: 1
                          }))
                        : (TimeDown.value == -1)
                          ? (_openBlock(), _createBlock(_component_VarButton, { key: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_VarLoading)
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_VarButton, {
                              key: 2,
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (SendEmailCode(registerObj.value.Email))),
                              type: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('components.LoginComponent.fasong')), 1)
                              ]),
                              _: 1
                            }))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"]),
                  _createVNode(_component_var_input, {
                    class: "input",
                    type: "tel",
                    modelValue: registerObj.value.Phone,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((registerObj.value.Phone) = $event)),
                    placeholder: _ctx.$t('components.LoginComponent.phone')
                  }, {
                    "prepend-icon": _withCtx(() => [
                      _createVNode(_component_var_icon, {
                        name: "shouji",
                        namespace: "icon"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"]),
                  _createVNode(_component_var_input, {
                    class: "input",
                    type: "password",
                    modelValue: registerObj.value.Password,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((registerObj.value.Password) = $event)),
                    placeholder: _ctx.$t('components.LoginComponent.dlmm')
                  }, {
                    "prepend-icon": _withCtx(() => [
                      _createVNode(_component_var_icon, {
                        name: "mima",
                        namespace: "icon"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"]),
                  _createVNode(_component_var_input, {
                    class: "input",
                    type: "text",
                    modelValue: registerObj.value.ParentAccountUid,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((registerObj.value.ParentAccountUid) = $event)),
                    placeholder: _ctx.$t('components.LoginComponent.yqm')
                  }, {
                    "prepend-icon": _withCtx(() => [
                      _createVNode(_component_var_icon, {
                        name: "mima",
                        namespace: "icon"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"]),
                  _createVNode(_component_VarButton, {
                    class: "login-button",
                    type: "primary",
                    onClick: ToRegisterAsync
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('components.LoginComponent.ljzc')), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_var_link, {
                      type: "primary",
                      underline: "none",
                      class: "hui-color"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('components.LoginComponent.yyzh')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_var_link, {
                      type: "primary",
                      underline: "none",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (ShowLogin(true)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('components.LoginComponent.qudenglu')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : (active.value == 'forgotPassword')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_var_input, {
                      class: "input",
                      type: "email",
                      modelValue: resetPasswordObj.value.Email,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((resetPasswordObj.value.Email) = $event)),
                      placeholder: _ctx.$t('components.LoginComponent.dzyj')
                    }, {
                      "prepend-icon": _withCtx(() => [
                        _createVNode(_component_var_icon, {
                          name: "youxiang",
                          namespace: "icon"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"]),
                    _createVNode(_component_var_input, {
                      class: "input",
                      type: "text",
                      modelValue: resetPasswordObj.value.EmailCode,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((resetPasswordObj.value.EmailCode) = $event)),
                      placeholder: _ctx.$t('components.LoginComponent.email_code')
                    }, {
                      "prepend-icon": _withCtx(() => [
                        _createVNode(_component_var_icon, {
                          name: "yanzhengyanzhengma",
                          namespace: "icon"
                        })
                      ]),
                      "append-icon": _withCtx(() => [
                        (TimeDown.value > 0)
                          ? (_openBlock(), _createBlock(_component_VarButton, {
                              key: 0,
                              type: "default"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(TimeDown.value) + "s ", 1)
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_VarButton, {
                              key: 1,
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (SendEmailCode(resetPasswordObj.value.Email))),
                              type: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('components.LoginComponent.fasong')), 1)
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"]),
                    _createVNode(_component_var_input, {
                      class: "input",
                      type: "password",
                      modelValue: resetPasswordObj.value.Password,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((resetPasswordObj.value.Password) = $event)),
                      placeholder: _ctx.$t('components.LoginComponent.dlmm')
                    }, {
                      "prepend-icon": _withCtx(() => [
                        _createVNode(_component_var_icon, {
                          name: "mima",
                          namespace: "icon"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"]),
                    _createVNode(_component_var_input, {
                      class: "input",
                      type: "password",
                      modelValue: resetPasswordObj.value.ResetPassword,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((resetPasswordObj.value.ResetPassword) = $event)),
                      placeholder: _ctx.$t('components.LoginComponent.qrmm')
                    }, {
                      "prepend-icon": _withCtx(() => [
                        _createVNode(_component_var_icon, {
                          name: "zhongfumima",
                          namespace: "icon"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"]),
                    _createVNode(_component_VarButton, {
                      class: "login-button",
                      type: "primary",
                      onClick: ResetPassword
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('components.LoginComponent.queren')), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_var_link, {
                        type: "primary",
                        underline: "none",
                        class: "hui-color"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('components.LoginComponent.yyzh')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_var_link, {
                        type: "primary",
                        underline: "none",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (ShowLogin(true)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('components.LoginComponent.qudenglu')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})